export default "__VITE_ASSET__BnrG$kyx__"